<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .manager-view {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(12px);
    padding-bottom: utils.in_rem(32px);
    position: relative;
    justify-content: space-between;

    .top-section {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(8px);
      position: relative;

      .top-row {
        display: flex;
        align-items: center;
        justify-content: center;
        height: utils.in_rem(48px);
        position: relative;
      }

      .status-banner {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>

<script>
  import { attendeesState } from "../attendeesState.svelte";
  import ConferenceCall from "../components/ConferenceCall.svelte";
  import DiallerTopRow from "../components/DiallerTopRow.svelte";
  import ManagerControls from "../components/ManagerControls.svelte";
  import ManagerStatusBanner from "../components/ManagerStatusBanner.svelte";

  const managerMode = $derived(attendeesState.manager?.mode);
  const user = $derived(attendeesState.user);
</script>

<div class="manager-view">
  <div class="top-section">
    <DiallerTopRow />

    <div class="status-banner">
      <ManagerStatusBanner
        mode={managerMode}
        userName={user?.firstName || user?.name}
      />
    </div>
  </div>

  <ConferenceCall />

  <div>
    <ManagerControls />
  </div>
</div>
